import type { FaireProductEntity } from "../../entity_types/product";

export const p_bkd9n7zmt9: FaireProductEntity = {
  token: "p_bkd9n7zmt9",
  type: "product",
  name: "Women's Buttery Soft Dream Jersey Cowl Neck Lounge Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/d999b729fcdc85f86853a0f7f1004039dec730c41e5fb3bc5ea07582d3a2c1c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32708ad10ffca0c10817106155152eb6d925346369e6e552e20c785279d73e24.jpeg",
    "https://cdn.faire.com/fastly/dbdf52f5e2db4f794a25f126c38ed92a8fb04d820cabb56f1d9ee75628ebac45.png",
    "https://cdn.faire.com/fastly/5460f91afb822b75b254a214c183babad057657ef9b1cf9140e0c03984eb3b06.jpeg",
    "https://cdn.faire.com/fastly/1250fa9ebb5e641ce8f2466e34c07086fba4921e919d4bd1d89d07633822f047.jpeg",
    "https://cdn.faire.com/fastly/908b60e9c16ed178e58b54fbc61bbe0967aa15e133e50fabeb6df5055af033e9.jpeg",
    "https://cdn.faire.com/fastly/299265421da57612227752b33a220afa1b6965546d79e7543b327ff41353ed1b.png",
    "https://cdn.faire.com/fastly/d30bb9a2b394a5f192d590d7c07483bcb8e9ec6a6558f7d558b985db85b2939a.jpeg",
    "https://cdn.faire.com/fastly/d94207384d2ea46a76d1cc4a373785ab6eec8551b054a47afdcf50239d5cf568.jpeg",
    "https://cdn.faire.com/fastly/8d17a108adedc1937901889beb917d0d0e1178ce5c7076f33bb26444db0d471f.jpeg",
    "https://cdn.faire.com/fastly/6165145d6520cc5d6e0680e1dd8e75ebac6e623e5874631268ebca5a972dc735.jpeg",
    "https://cdn.faire.com/fastly/50b03df47e79376d8c0f39035011e44c628106a8ae6dcbad7a2f8f07811bac37.jpeg",
    "https://cdn.faire.com/fastly/3b8f8e0dbfe6dba598ec83262262d67616808142d013650990532221f412284f.jpeg",
    "https://cdn.faire.com/fastly/59af7474128efd6c0f900494395f2681529db08f181a6760403958b363d3ea50.png"
  ],
  priceDollars: 60,
  description: "Ease into moments of comfort that feel effortlessly refined from the first wear. Designed for slow mornings, relaxed evenings, and everything in between, this lounge set brings an elevated touch to everyday downtime.\n\nFabrication:\nMade from Softies' Dream Jersey fabric, this set features a lightweight feel with a smooth, ultra-soft finish. The comfortable stretch and fluid drape create an easy silhouette that moves with you throughout the day.\n\nFeatures:\n● Relaxed cowl neckline adds a polished, feminine touch\n● Coordinating long pants create an effortlessly put-together look\n● Stretch-infused fabric provides comfort and freedom of movement\n● 28\" Pant Inseam with Elastic Waistband  \n\n\nMaterials & Care:\n● 96% Polyester, 4% Spandex\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n\nBest For:\n● Relaxing at home in comfort\n● Travel and weekend lounging\n● Morning routines and evening unwinding",
  tags: [],
  msrpDollars: 129,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:18.421Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
